export default __webpack_public_path__ + "static/media/img6.fa02e18e.PNG";